import React, { useEffect, useState, useCallback } from 'react';
import { Box } from '@material-ui/core';
import { Text, Button, Preloader } from '../../../../atoms';

import { IoMdClose } from 'react-icons/io';
import { IoCopyOutline } from 'react-icons/io5';

import { getScheduleExport } from '../../../../../services/api';


const ModalCalendarURL = ({ contentModal = {}, onClose }) => {
    
    //'https://calendario.empresa.com/sync?user=renan.santos&token=abc123xn=abc123renan.santos&token=abc123xn=abc123'
    const [currentURL, setCurrentURL] = useState(null);

    const [statusCopy, setCopied] = useState(false);

    const handleScheduleExport = useCallback(async () => {
        const res = await getScheduleExport();
        setCurrentURL(res.data.result);
    }, []);

    useEffect(() => {
        handleScheduleExport();
    }, [handleScheduleExport]);

    const handleCopyUrl = async () => {
        try {
            await navigator.clipboard.writeText(currentURL);
            setCopied(true);

            // volta para false depois de 2s
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Erro ao copiar: ', err);
        }
    };

    return (
        <Box
            sx={{
                position: 'absolute',
                top: '40%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '100%' },
                maxWidth: { xs: '100%', sm: '750px' },
                bgcolor: 'background.paper',
                p: 4,
            }}
        >
            {currentURL ? (
                <>
                    <div className="containerBtnModalCalendarURL">
                        <Button
                            ico={IoMdClose}
                            callEvent={(e) => {
                                onClose();
                            }}
                        />
                    </div>
                    <Text component="h2" text={'Sincronizar com meu calendário'} />
                    <Text
                        component="p"
                        text={`Use o <b>link abaixo para sincronizar seu calendário do LMS</b> com ferramentas externas, como Google Calendar ou Outlook.`}
                    />
                    <Text
                        component="p"
                        text={`Copie e cole o link como <b>Calendário por URL</b> ou <b>Assinatura de calendário</b> no aplicativo que você preferir.`}
                    />

                    <div className="urlBase">
                        <div className="urlLink" onClick={handleCopyUrl}>
                            <div className="urlText">{currentURL}</div>
                            <IoCopyOutline />
                        </div>
                        {statusCopy && <Text className="linkConfirm" component="small" text={`Link copiado`} />}
                    </div>
                </>
            ) : (
                <div className='preloaderContainer'>
                
                 <Preloader />
                </div>
            )}
        </Box>
    );
};

export default ModalCalendarURL;
